import { http, HttpResponse } from 'msw';

import { SelectedConsolidations } from '../../types/ConsolidationTypes';

const selectedConsolidationsResponse: SelectedConsolidations = {
    consolidations: [
        {
            creditorName: 'Wayne Bank',
            internalId: '123',
            currentBalance: {
                amount: 20000,
                currency: 'NOK',
            },
            nominalInterestRate: 14.3,
            tenor: 24,
            accountNumber: '',
            accountType: 'REPAYMENT_LOANS',
            kidNumber: '',
            applicantType: 'MAIN',
            shortId: '123',
            consolidationType: 'FULL',
        },
        {
            creditorName: 'Nordea',
            internalId: '456',
            currentBalance: {
                amount: 100000,
                currency: 'NOK',
            },
            consolidationAmount: {
                amount: 50000,
                currency: 'NOK',
            },
            nominalInterestRate: 10,
            tenor: 38,
            accountNumber: '',
            accountType: 'CREDIT_FACILITY',
            kidNumber: '',
            applicantType: 'MAIN',
            shortId: '456',
            consolidationType: 'PARTIAL',
        },
        {
            internalId: '321',
            currentBalance: {
                amount: 10000,
                currency: 'NOK',
            },
            nominalInterestRate: 15.1,
            tenor: 12,
            accountNumber: '',
            accountType: 'CHARGE_CARDS',
            kidNumber: '',
            applicantType: 'MAIN',
            shortId: '321',
            consolidationType: 'FULL',
        },
        {
            creditorName: 'DNB',
            internalId: '789',
            currentBalance: {
                amount: 40000,
                currency: 'NOK',
            },
            nominalInterestRate: 10,
            tenor: 38,
            accountNumber: '',
            accountType: 'CHARGE_CARDS',
            kidNumber: '',
            applicantType: 'CO',
            shortId: '789',
            consolidationType: 'FULL',
        },
    ],
};
export const getSelectedConsolidationsHandlers = [
    http.get('*/api/cl_loanapp_proxy_service/v1/:countryCode/consolidation/:arn', async () => {
        return HttpResponse.json(selectedConsolidationsResponse);
    }),
];
